<template>
  <div style="margin-right:5px; margin-bottom:5px">
    <b-tooltip position="is-left" :label="this.$t('sondage.deleted-question')">
      <div style="margin-left:10px; margin-top:5px;" @click="removeQuestion()">
        <img src="@/assets/img/icons/delete.png" class="icon" alt="icon-delete" />
      </div>
    </b-tooltip>
  </div>
</template>

<script>
export default {
  methods: {
    removeQuestion () {
      if (this.indexSection >= 0) {
        this.$store.commit('REMOVE_QUESTION', {
          type: 'section',
          indexSection: this.indexSection,
          indexQuestion: this.indexQuestion
        })

        this.$buefy.toast.open({
          message: this.$i18n.t('toast.question.deleted-question'),
          type: 'is-danger'
        })
      } else {
        this.$store.commit('REMOVE_QUESTION', {
          type: 'question',
          indexQuestion: this.indexQuestion
        })
        this.$buefy.toast.open({
          message: this.$i18n.t('toast.question.deleted-question'),
          type: 'is-danger'
        })
      }
      this.$store.commit('TEST_SAVE_QUESTION_BUTTON')
    }
  },
  props: {
    indexQuestion: {
      type: Number,
      required: true
    },
    indexSection: {
      type: Number,
      required: false
    }
  }
}
</script>
<style scoped>
.icon {
  width: 20px;
  height: 20px;
  vertical-align: center;
  margin-left:5px;
  cursor:pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/question/components/RemoveQuestionButton.vue